<div class="topHead">
    <a href="javascript:void(0);" class="adminBack"(click)="open(back)"><img src="assets/images/admin/backarrow.png" /> Back to course Management</a>
    <!-- <div class="logout">
        <b>{{adminData.first_name+" " + adminData.last_name}}</b>
        <a href="javascript:void(0);" (click)="logout()"><img src="assets/images/admin/power.png"/> </a>
    </div> -->
    <div class="logout">
        <app-log-out class="logout"></app-log-out>
    </div>
</div>
<div class="formHeading pr-0">
    <div class="row m-0">
        <div class="col-12 col-md-8">
            <h2>Create Course</h2>
        </div>
     </div>
</div>
<div class="dynamicBookWrap">
    <div class="container">
        <div class="row">
            <div class="resultWrap mw-100 pt-5 mt-0">
                <div class="resul_img">
                    <img src="assets/images/illus.png" />
                </div>
                    <h4>You have successfully published a new course!</h4>
                    <span class="divider"></span>
                    <div class="mt-4 mb-4">
                        <h6 class="btn-link size18 mb-0 ">{{courseData.course_name}}</h6>
                        <div class="assignOn">
                            <span>{{courseData.module_count}} Modules</span>
                            <span>{{courseData.submodule_count}} Sub Modules</span>
                            <span>{{courseData.assessment_count}} Assessment</span>
                        </div>
                        <div class="assignOn">
                            <span>End Date: {{courseData.end_date}}</span> 
                        </div>
                    </div>
                    <div class="illusBtnWrap">
                    <div class="btnWrap">
                        <a href="javascript:void(0);" [routerLink]="['/courses']" class="backPage ml-2 mr-2">Go back to course management</a>
                        <a href="javascript:void(0);" class="btn btn-primary btn-sm ml-2 mr-2" [routerLink]="['/courses_view_courses']"
                        [queryParams]="{courseId:courseId}">VIEW COURSE DETAILS</a>
                        <a href="javascript:void(0);" *ngIf="key" class="btn btn-primary btn-sm ml-2 mr-2" [routerLink]="['/courses_assign_after_published']"
                        [queryParams]="{courseId:courseId}">ASSIGN USERS</a>
                    </div>
                    </div>
            </div>
        </div>
    </div>
</div>
<ng-template #back let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Back to course </h6>
                <p class="size18">Are you sure you would like to back to course ?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="CloseIds">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')"
                    class="backPage ml-2 mr-2">Cancel</a>
                <a href="javascript:void(0);"  class="btn btn-primary btn-sm" (click)="cancelbk()">Confirm</a>
            </div>
        </div>
    </div>
</ng-template>
    

     
     
 

 
  